import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  
  if (location.pathname.includes('/worlds/')) {
    return null;
  }
  
  return (
    <header className="header">
      <div className="logo">
        <Link to="/">VR World Platform</Link>
      </div>
      
      <nav className="nav">
        {user ? (
          <>
            <Link to="/worlds">Worlds</Link>
            <span className="user-info">Welcome, {user.username}</span>
            <button className="logout-button" onClick={logout}>Logout</button>
          </>
        ) : (
          <Link to="/">Login</Link>
        )}
      </nav>
    </header>
  );
}

export default Header; 